import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchZones() {
  const { data } = await axios.get(`${API}/zones`);
  return data.zones;
}

export async function fetchBriefing(zoneId) {
  const { data } = await axios.get(`${API}/briefing/${zoneId}`);
  return data; // { zone_id, title, index, intro, progressive, traditional }
}

// Requests server-side TTS synthesis (cached) and returns a fully-qualified audio URL.
export async function synthesize(text, voice = 'sage') {
  const { data } = await axios.post(`${API}/tts`, { text, voice });
  return `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
}

export async function fetchProfile(id) {
  const { data } = await axios.get(`${API}/profile/${id}`);
  return data; // { id, title, text }
}
